// extracted by mini-css-extract-plugin
export var audioPlayer = "_sn-0";